import { useEffect } from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import ShelfArgument from "./components/ShelfArgument";
import TheRange from "./components/TheRange";
import WhatWeContribute from "./components/WhatWeContribute";
import Exclusivity from "./components/Exclusivity";
import TradeData from "./components/TradeData";
import Certifications from "./components/Certifications";
import WhereWeShip from "./components/WhereWeShip";
import Faq from "./components/Faq";
import TerritoryForm from "./components/TerritoryForm";
import Footer from "./components/Footer";

export default function OrganicDistributors() {
  useEffect(() => {
    document.title = "Organic Cane Sugar & Cocoa for Distributors | Mesa Baja Colombia";
    const meta = document.querySelector('meta[name="description"]');
    if (meta) {
      meta.setAttribute(
        "content",
        "Certified organic unrefined cane sugar and cocoa powder from Colombia, retail-ready and offered under territory exclusivity. Ecocert USDA and EU Organic. Check availability."
      );
    }
  }, []);

  return (
    <main className="min-h-screen bg-cream">
      <Header />
      <Hero />
      <ShelfArgument />
      <TheRange />
      <WhatWeContribute />
      <Exclusivity />
      <TradeData />
      <Certifications />
      <WhereWeShip />
      <Faq />
      <TerritoryForm />
      <Footer />
    </main>
  );
}